import React, { useState, useEffect, useRef } from 'react'
import { Alert } from "@mui/material";
import Select from "react-select";
import Swal from 'sweetalert2';
import Moment from 'moment';
import { Calendar, Empty } from 'antd';
// import './RateUpdate.css'
import Modal from 'react-bootstrap/Modal'
import { baseURL } from '../backend_url';
import axios from 'axios';
import moment from 'moment';
// import { ExportToExcel } from './ExportToExcel'
// import { ExportToExcelWithRates } from './ExportToExcelWithRates';
// import ExcelUpload from './ExcelUpload';
import MultiRangeSlider from "multi-range-slider-react";
import RangeSlider from "react-bootstrap-range-slider";
import { isEmpty } from 'lodash';
import ProgressBar from './ProgressBar';
import './loader.css';
import { DatePicker } from "antd";
import expedia from './expedia_logo.jpg'
import ace from './ace.png'
import budget from './budget.jpg'
import europcar from './europcar.jpg'
import dollar from './dollar.jpg'
import national from './national.png'
import alamo from './alamo.png'
import advantage from './advantage.jpg'
import routes from './routes.jpg'
import fox from './fox.jpg'
import thrifty from './thrifty.jpg'
import greenMotion from './greenMotion.jpg'
import { ExportToExcelWithRates } from './ExportToExcelWithRates';
import { PushToRateUpdate } from './PushToRateUpdate';




export default function UpdateForm({ accessType }) {
    const [selectedRow, setSelectedRow] = useState(-1);
    const [editedPrices, setEditedPrices] = useState({});
    const [tetheringShow, setTetheringShow] = useState(false);
    const [currencyShow, setCurrencyShow] = useState(false);
    const [trueKeys, setTrueKeys] = useState({});
    const [defaultDate, setDefaultDate] = useState(new Date())
    const [defaultCheck, setDefaultCheck] = useState({})
    const [currencyConversionValue, setCurrencyConversionValue] = useState(1);
    const daysNameTable = [['Monday', 'Friday'], ['Tuesday', 'Saturday'], ['Wednesday', 'Sunday'], ['Thursday', null]]
    const [checkAll, setCheckAll] = useState(false)
    // const changeDaysCheckBox = (key) => {
    //     let temp = { ...daysNameHash };
    //     let status = temp[key]
    //     temp[key] = !status

    //     setDaysNameHash(temp);
    // }

    const changeDaysCheckBox = (key, day, checked) => {
        let countFalses = countFalseValues()
        if (checked == true && countFalses == 1) {
            setDefaultCheck({ ...defaultCheck, [key]: true });
        }
        if (checked == false) {
            setDefaultCheck({ ...defaultCheck, [key]: checked });

        }
        updateRowData(key, { ...rowData[key], [day]: checked });
    };

    const countFalseValues = () => {
        let count = 0;
        for (let key in rowData) {
            for (let day in rowData[key]) {
                if (!rowData[key][day]) {
                    count++;
                }
            }
        }
        return count;
    }
    const changeAllDaysCheckBox = (key, checked) => {

        // console.log("im checked all")
        // console.log("checked",checked)
        // console.log("checked2",rowData[key])
        // setDefaultCheck(checked);
        // updateRowData(key, { ...rowData[key], defaultCheck: checked });
        // updateRowData(key, { ...rowData[key], ['selectedAll']: checked });
        // let temp = { ...daysNameHash }
        if (checked == true) {
            setDefaultCheck({ ...defaultCheck, [key]: checked });
            let temp = { ...daysNameHash };
            let updatedData = { ...rowData[key] }; // Initialize updatedData with existing rowData[key]
            for (const day of Object.keys(temp)) {
                updatedData[day] = true; // Update the value for all days to true
            }
            setRowData({ ...rowData, [key]: updatedData });
        } else if (checked == false) {
            setDefaultCheck({ ...defaultCheck, [key]: checked });
            let temp = { ...daysNameHash };
            let updatedData = { ...rowData[key] }; // Initialize updatedData with existing rowData[key]
            for (const day of Object.keys(temp)) {
                updatedData[day] = false; // Update the value for all days to true
            }
            setRowData({ ...rowData, [key]: updatedData });
        }
    };

    const changeAllDaysCheckBox2 = (key, checked) => {
        let temp = { ...daysNameHash }
        if (selectAllDaysFlag === true) {
            setSelectAllDaysFlag(false)
            let keys = Object.keys(temp)
            for (let i = 0; i < keys.length; i++) {
                temp[keys[i]] = false
            }
        }
        else {
            setSelectAllDaysFlag(true)
            let keys = Object.keys(temp)
            for (let i = 0; i < keys.length; i++) {
                temp[keys[i]] = true
            }
        }
        setDaysNameHash(temp)
        // setPreloadFlag(true)
    }


    // const [showPopup, setShowPopup] = useState(false)

    const [isChecked, setIsChecked] = useState(false);
    const [currentTab, setCurrentTab] = useState(null);
    const [rowData, setRowData] = useState({});

    const handleCheckboxChange = (index) => {
        setSelectedRow(index === selectedRow ? null : index);
    };

    const currencyOption = [
        { id: 1, value: "USD", label: "USD" },
        { id: 2, value: "CAD", label: "CAD" },
        { id: 2, value: "EUR", label: "EUR" },
    ];
    const rateCodeOptions = [
        { id: 1, value: "Both", label: "Both" },
        { id: 2, value: "Pay On Arrival", label: "Pay On Arrival" },
        { id: 2, value: "Prepaid", label: "Prepaid" },
    ];



    const handleAccept5 = () => {
        // window.location.reload();
        // console.log(selectedLowestValue)
        // console.log(selectedIndex)

        if (Array.isArray(selectedLowestValue) && selectedLowestValue.length === 0) {
            Swal.fire('Please select at any Strategy data');
            return;
        }

        let keysWithEmptyValues = [];
        for (let i = 0; i < selectedLowestValue.length; i++) {
            const obj = selectedLowestValue[i];
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (isNaN(obj[key]) || obj[key] === 0) {
                        keysWithEmptyValues.push(key);
                    }
                }
            }
        }

        if (keysWithEmptyValues.length > 0) {
            const keysMessage = keysWithEmptyValues.join(', ');
            Swal.fire(`The following Car Classes have empty prices: ${keysMessage}. Please enter the Price.`);
            return;
        }

        const body_payload =
        {
            account_id: company_id.toString(),
            location_id: locationId.toString(),
            pickup_time: selectedPickUpTime,
            sipp_code: selectedCarClass,
            strategyOptions: selectedOptions,
            carClassData: selectedLowestValue,
            updatingLOr: selectedIndex,
            from_date: new Date(fromDate).toDateString(),
            created_by: loggedInUserDetail.userEmail,
            updated_by: loggedInUserDetail.userEmail,
            created_date: new Date(),
            updated_date: new Date()
        };
        // console.log(body_payload)
        // return

        axios
            .post(baseURL + "/save_instant_pro_in_rate_update", body_payload)
            .then((res2) => {
                // if (res2 !== null &&  res2.data === 'Success') {
                //     Swal.fire('Rates are updated Successfully')
                // }else{
                //     Swal.fire('Error in updating the Rates')
                // }
                // scrollToBottom();
                // setTimeDuration(1)
                // setLoading2(false);
                // setLoading(false);
                console.log("res2:", res2)
                // console.log(fromDate)

            });
    }

    // const handlePriceChange = (e, carClass, priceIndex) => {
    //   const newEditedPrices = { ...editedPrices };
    //   if (!newEditedPrices[carClass]) {
    //     newEditedPrices[carClass] = [...Array(Object.values(responseData[activeTab]?.competitors_result || {})[0].length).fill('')];
    //   }
    //   newEditedPrices[carClass][priceIndex] = e.target.value;
    //   setEditedPrices(newEditedPrices);
    // };

    const fetchRates = () => {
        // Fetch rates for the selected row
        if (selectedRow !== null) {
            // Perform your fetch operation here using selectedRow
            console.log("Fetching rates for row:", selectedRow);
            console.log("Edited prices:", editedPrices);
        } else {
            console.log("No row selected");
        }
    };


    const formatDate = (date) => {
        return [
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
            date.getFullYear(),
        ].join('-');
    }

    const CustomLoader = () => {
        const [letters, setLetters] = useState(
            Array.from({ length: 5000 }).map(() => randomLetter())
        );
        const [scaleY, setScaleY] = useState(0); // Scale along Y-axis
        const [currentIndex, setCurrentIndex] = useState(0); // Index of the current letter to display

        useEffect(() => {
            const interval = setInterval(() => {
                // Update the scale along the Y-axis
                if (scaleY < 1) {
                    setScaleY(scaleY + 0.005); // Increment the scale gradually
                }
            }, 50); // Decreased interval for smoother animation

            return () => clearInterval(interval);
        }, [scaleY]);

        useEffect(() => {
            const interval = setInterval(() => {
                // Update the positions of the letters based on time
                const time = Date.now();
                const newLetters = letters.map((_, index) => {
                    const radiusX = 300 - index * 0.3; // Adjust the radius along the X-axis inversely with time
                    const radiusY = 150 - index * 0.3; // Adjust the radius along the Y-axis inversely with time
                    const angle = index * 0.05; // Adjust the angle increment for the elliptical path
                    const transformedAngle = angle + time / 10000;
                    const x = 960 + radiusX * Math.cos(transformedAngle);
                    const y = 540 + radiusY * Math.sin(transformedAngle) * scaleY;
                    return { x, y };
                });
                setLetters(newLetters);
            }, 50); // Decreased interval for smoother animation

            return () => clearInterval(interval);
        }, [letters, scaleY]);

        useEffect(() => {
            const timeout = setTimeout(() => {
                // Update the index of the current letter to display
                if (currentIndex < "Fetching Live Rates.....".length) {
                    setCurrentIndex(currentIndex + 1);
                } else {
                    setCurrentIndex(0); // Reset index to restart animation
                }
            }, 10); // Interval for displaying each letter

            return () => clearTimeout(timeout);
        }, [currentIndex]);

        function randomLetter() {
            // const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const alphabet = "0123456789";
            return alphabet[Math.floor(Math.random() * alphabet.length)];
        }

        return (
            <div style={{ marginLeft: "5%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', width:'100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.7 }}>
            <svg
                viewBox="0 0 1920 1080"
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
            >
                <rect width="110%" height="100%" fill="#061434" />
                {letters.map((letter, index) => (
                    <text key={index} x={letter.x} y={letter.y} fill="#7D9DDF">
                        {randomLetter()}
                    </text>
                ))}
                <text
                    x="50%"
                    y="50%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fill="white"
                    fontSize="68"
                >
                    {currentIndex > 0
                        ? "Fetching Live Rates.....".substring(0, currentIndex)
                        : ""}
                </text>
            </svg>
        </div>
        
        );
    };


    // const CustomLoader = () => {
    //     return (
    //         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
    //             <h2 style={{ color: '#fff', marginBottom: '20px' }}>Please wait, while we are fetching the live rates for you...</h2>
    //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    //                 <img src={routes} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveLeftToRight 2s infinite linear' }} />
    //                 <img src={ace} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveLeftToRight 2s infinite linear' }} />
    //                 <img src={national} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveLeftToRight 2s infinite linear' }} />
    //                 <img src={alamo} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveLeftToRight 2s infinite linear' }} />
    //                 <img src={dollar} alt="Loader" style={{ width: '80px', height: '50px', animation: 'moveLeftToRight 2s infinite linear' }} />
    //             </div>
    //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
    //                 <img src={budget} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveRightToLeft 2s infinite linear' }} />
    //                 <img src={europcar} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveRightToLeft 2s infinite linear' }} />
    //                 <img src={fox} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveRightToLeft 2s infinite linear' }} />
    //                 <img src={greenMotion} alt="Loader" style={{ width: '80px', height: '50px', marginRight: '10px', animation: 'moveRightToLeft 2s infinite linear' }} />
    //                 <img src={thrifty} alt="Loader" style={{ width: '80px', height: '50px', animation: 'moveRightToLeft 2s infinite linear' }} />
    //             </div>
    //             <style>
    //                 {`
    //                     @keyframes moveLeftToRight {
    //                         0% {
    //                             transform: translateX(-100%);
    //                         }
    //                         100% {
    //                             transform: translateX(100%);
    //                         }
    //                     }

    //                     @keyframes moveRightToLeft {
    //                         0% {
    //                             transform: translateX(100%);
    //                         }
    //                         100% {
    //                             transform: translateX(-100%);
    //                         }
    //                     }
    //                 `}
    //             </style>
    //         </div>
    //     );
    // };

    const formatDate_Modal = (date) => {
        return [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate())
        ].join('-');
    }

    const padTo2Digits = (num) => {
        return num.toString().padStart(2, '0');
    }

    const handleRefresh = () => {
        window.location.reload();
    };

    const [loading2, setLoading2] = useState(false);
    const [competitorsList, setCompetitorsList] = useState([{}]);
    const [selectedPickUpTime, setSelectedPickUpTime] = useState('');
    const [locationCurrency, setLocationCurrency] = useState('');
    const [selectedRateParity, setSelectedRateParity] = useState('Static');
    const [numbers, setNumbers] = useState({ "1": false, "2": false, '3': false, '4': false, '5': false, '6': false, 'Weekly': false, 'Monthly': false })
    // const [strategyOptions, setStrategyOptions] = useState({'Lowest' : false, '2nd Lowest' : false, '3rd Lowest' : false, 'Lowest Off-Airport' : false, '2nd Lowest Off-Airport' : false, '3rd Lowest Off-Airport' : false, 'Lowest In-Terminal' : false, '2nd Lowest In-Terminal' : false, '3rd Lowest In-Terminal' : false, 'Lowest among all the Car Classes' : false, 'Leave as it is' : false});
    const [strategyOptions, setStrategyOptions] = useState({
        'Lowest': false,
        '2nd Lowest': false,
        '3rd Lowest': false,
        'Lowest Off-Airport': false,
        '2nd Lowest Off-Airport': false,
        '3rd Lowest Off-Airport': false,
        'Lowest In-Terminal': false,
        '2nd Lowest In-Terminal': false,
        '3rd Lowest In-Terminal': false,
        'Lowest among all the Car Classes': false,
        // 'Leave as it is': false,
    });
    const [loading, setLoading] = useState(false);

    // const handleOptionChange = (option) => {
    //     setStrategyOptions({
    //       ...strategyOptions,
    //       [option]: !strategyOptions[option],
    //     });
    // };

    const handleSelectAllStrategies = () => {
        const allSelected = Object.values(strategyOptions).every((value) => value === true);
        const updatedOptions = {};

        for (const option in strategyOptions) {
            updatedOptions[option] = !allSelected;
        }

        setStrategyOptions(updatedOptions);
    };



    const chunkArray = (array, size) => {
        const chunkedArr = [];
        for (let i = 0; i < array.length; i += size) {
            chunkedArr.push(array.slice(i, i + size));
        }
        return chunkedArr;
    };

    const optionsArray = Object.entries(strategyOptions);
    const rows = chunkArray(optionsArray, 3);
    // const [responseData, setResponseData] = useState(null);
    const [responseData, setResponseData] = useState({});
    const [activeTab, setActiveTab] = useState(null);

    // const competitors = Object.keys(responseData.competitors);
    // const carClasses = Object.keys(responseData.lowest_total);

    const mainDropdownOptions = ['Lowest', '2nd Lowest', '3rd Lowest', 'Lowest Off-Airport', '2nd Lowest Off-Airport', '3rd Lowest Off-Airport', 'Lowest In-Terminal', '2nd Lowest In-Terminal', '3rd Lowest In-Terminal', 'Lowest among all the Car Classes', 'Custom', 'Leave as it is'];
    const changeOptions = ['Dollar ($)', 'Percentage (%)']; // Replace this with your additional dropdown options
    const [sippValues, setSelectedSippValues] = useState([]);
    const [sippValues2, setSelectedSippValues2] = useState([]);
    const [sippValues3, setSelectedSippValues3] = useState([]);
    const [selectedStrategy, setSelectedStrategy] = useState([]);
    const [selectedAmount, setSelectedAmount] = useState([]);
    const [selectedCompetitor, setSelectedCompetitor] = useState([]);
    const [selectedChange, setSelectedChange] = useState([]);
    const [timeDuration, setTimeDuration] = useState(0);
    const [selectedRateSourceOption, setSelectedRateSourceOption] = useState('Expedia');
    const [selectedCurrencyOption, setSelectedCurrencyOption] = useState('USD');
    const [selectedRateCodeOption, setSelectedRateCodeOption] = useState('ALL');
    const [selectedCompetitionOption, setSelectedCompetitionOption] = useState('SIPP CODE');
    const [expediaOptions, setExpediaOptions] = useState(['Economy', 'Compact', 'MidSize', 'Standard', 'Full-Size', 'Premium', 'Luxury', 'Convertible', 'Minivan', 'SUV', 'Compact SUV', 'Midsize SUV', 'Standard SUV', 'Standard Elite SUV', 'Fullsize SUV', 'Premium SUV', 'Luxury SUV', 'Special SUV', 'Van', 'Pickup', 'Sports Car', 'Other']);
    const [companyDetail, setcompanyDetail] = useState([{}]);
    const [companyName, setCompanyName] = useState("");
    const [company_id, setcompany_id] = useState("");
    const [locationDetail, setLocationDetail] = useState([{}]);
    const [locationName, setLocationName] = useState("");
    const [locationId, setLocationId] = useState("");
    const [headerData, setHeaderData] = useState("");
    const [listOfRateCodes, setListOfRateCodes] = useState({})
    const [table, setTable] = useState([])
    const [daysNameHash, setDaysNameHash] = useState({ "Monday": false, "Tuesday": false, 'Wednesday': false, 'Thursday': false, 'Friday': false, 'Saturday': false, 'Sunday': false })
    const [carDetails, setCarDetails] = useState([])
    const [carDetailsInOption1, setCarDetailsInOption1] = useState([])
    const [carDetailsInOption2, setCarDetailsInOption2] = useState([])
    const [carDetailsInOptionConstant, setCarDetailsInOptionConstant] = useState([])
    const [fleetStandardCarDetails, setFleetStandardCarDetails] = useState([])
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [selectAllDaysFlag, setSelectAllDaysFlag] = useState(true)
    const [instantAutomationShow, setInstantAutomationShow] = useState("NO")
    const [fromDate, setFromDate] = useState(new Date())
    const [toDate, setToDate] = useState(new Date())
    const [instantFromDate, setInstantFromDate] = useState(new Date());
    const [instantToDate, setInstantToDate] = useState(new Date());
    const [instantTetherDate, setInstantTetherDate] = useState(new Date());

    const [dateArr, setDateArr] = useState([])
    const [selectedDatePicker, setSelectedDatePicker] = useState('')
    const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
    const [rateCodeNames, setRateCodeNames] = useState({})
    const [allCarClassData, setAllCarClassData] = useState([]);
    const [selectedCarClass, setSelectedCarClass] = useState([]);
    const [carClassAll, setCarClassAll] = useState(false);
    const [allCompetitors, setAllCompetitors] = useState([]);
    const [selectedCompetitors, setSelectedCompetitors] = useState([]);
    const [competitorsAll, setCompetitorsAll] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState('');

    const [selectedLowestValue, setSelectedLowestValue] = useState({});
    const [selectedIndex, setSelectedIndex] = useState('');


    // const handleOptionChange = (event) => {
    //     setSelectedOption(event.target.value);
    // };
    const handleOptionChange = (e) => {
        const { value } = e.target;
        if (selectedOptions.includes(value)) {
            setSelectedOptions(selectedOptions.filter(option => option !== value));
        } else {
            setSelectedOptions([...selectedOptions, value]);
        }
    };


    const rateSourceOptions = [
        { value: "Expedia", label: "Expedia" },
        { value: "Priceline", label: "Priceline" }
    ];

    const competitionOptions = [
        { value: "SIPP CODE", label: "SIPP CODE" },
        // { value: "Car Category", label: "Car Category" }
    ];

    const parityOptions = [
        { value: "Static", label: "Static" },
        { value: "Multiple of LOR", label: "Multiple of LOR" }
    ];

    const handleCarClass = (val) => {
        let tempObj = { ...selectedCarClass };
        tempObj[val] = !selectedCarClass[val];

        let keyArr = Object.keys(tempObj);

        let count = 0;
        for (let i = 0; i < keyArr.length; i++) {
            if (tempObj[keyArr[i]] === true)
                count++;
        }

        if (count < keyArr.length) {
            setCarClassAll(false)
        }
        else {
            setCarClassAll(true)
        }
        setSelectedCarClass(tempObj);
    }

    //   const handleLowestValues = (val, val2) => {
    //     console.log("lowest Values")
    //     console.log(val)
    //     console.log(val2)
    //     setSelectedLowestValue(val)
    //     console.log(selectedLowestValue)

    //   }
    // const handleLowestValues = (value, rowIndex) => {
    //     setSelectedLowestValue(value)
    //     setSelectedIndex(rowIndex)
    //     console.log(value)
    //     console.log(rowIndex)
    // };

    const updateRowData = (key, newData) => {
        setRowData(prevData => ({
            ...prevData,
            [key]: newData
        }));
    };

    // const handleDatePickerChange = (key, value) => {
    //     console.log("date value",value._d)
    //     setDefaultDate(value._d)
    //     updateRowData(key, { ...rowData[key], date: value });
    // };

    const handleDatePickerChange = (key, date) => {
        console.log("date value", date._d);
        setDefaultDate(date._d);
        updateRowData(key, { ...rowData[key], defaultDate: date._d });
    };

    const handleLowestValues = (rowData, tab) => {
        const rowData_temp = JSON.parse(JSON.stringify(rowData));
        setSelectedLowestValue(prevState => ({
            ...prevState,
            [tab]: rowData_temp,
        }));
        setCurrentTab(tab)
        // console.log('tab:', tab);
        // console.log('rowData:', rowData_temp)
        // console.log('hhhhhhhhhhhhhh:', selectedLowestValue)
    };

    // const handlePriceChange = (e, carClass) => {
    //     const { value } = e.target;

    //     // Find the index of the selected row
    //     const rowIndex = selectedLowestValue.findIndex(row => Object.keys(row).includes(carClass));

    //     // If the selected row exists
    //     if (rowIndex !== -1) {
    //         // Update the price for the specified car class
    //         const updatedRow = {
    //             ...selectedLowestValue[rowIndex],
    //             [carClass]: parseFloat(value) // Assuming prices are numeric, parse the value as float
    //         };

    //         // Update the selectedLowestValue array with the updated row
    //         const updatedLowestValues = [
    //             ...selectedLowestValue.slice(0, rowIndex),
    //             updatedRow,
    //             ...selectedLowestValue.slice(rowIndex + 1)
    //         ];

    //         // Update the state with the modified array
    //         setSelectedLowestValue(updatedLowestValues);
    //         console.log('selectedLowestValue:', updatedLowestValues);
    //     }

    // };  
    const handlePriceChange = (e, carClass) => {

        const { value } = e.target;
        const updatedLowestValues = JSON.parse(JSON.stringify(selectedLowestValue));
        updatedLowestValues[activeTab][0][carClass] = value

        setSelectedLowestValue(updatedLowestValues);

    };

    const handleTabClick = (e, tab) => {
        setActiveTab(tab);
    };

    // const handleTabClick = (e, tabKey) => {
    //     e.preventDefault(); // Prevent the default form submission behavior
    //     setActiveTab(tabKey);
    //     setSelectedLowestValue([])
    //     // setSelectedIndex(selectedIndex)
    // };


    const handleCompetitors = (val) => {
        // console.log(val)
        let tempObj = { ...selectedCompetitors };
        tempObj[val] = !selectedCompetitors[val];

        let keyArr = Object.keys(tempObj);

        let count = 0;
        for (let i = 0; i < keyArr.length; i++) {
            if (tempObj[keyArr[i]] === true)
                count++;
        }

        if (count < keyArr.length) {
            setCompetitorsAll(false)
        }
        else {
            setCompetitorsAll(true)
        }
        setSelectedCompetitors(tempObj);
    }

    const handleSelectedCompetitors = (val) => {

        setCompetitorsAll(val)
        let tempObj = { ...selectedCompetitors };
        let keyArr = Object.keys(selectedCompetitors);

        for (let i = 0; i < keyArr.length; i++) {

            tempObj[keyArr[i]] = val;
        }
        setSelectedCompetitors(tempObj);
    }

    const handleCarClassAll = (val) => {

        setCarClassAll(val)
        let tempObj = { ...selectedCarClass };
        let keyArr = Object.keys(selectedCarClass);

        for (let i = 0; i < keyArr.length; i++) {

            tempObj[keyArr[i]] = val;
        }

        setSelectedCarClass(tempObj);
    }

    const hours = [
        { "name": "00:00" }, { "name": "00:30" }, { "name": "01:00" }, { "name": "01:30" }, { "name": "02:00" }, { "name": "02:30" }, { "name": "03:00" },
        { "name": "03:30" }, { "name": "04:00" }, { "name": "04:30" }, { "name": "05:00" }, { "name": "05:30" }, { "name": "06:00" }, { "name": "06:30" },
        { "name": "07:00" }, { "name": "07:30" }, { "name": "08:00" }, { "name": "08:30" }, { "name": "09:00" }, { "name": "09:30" }, { "name": "10:00" },
        { "name": "10:30" }, { "name": "11:00" }, { "name": "11:30" }, { "name": "12:00" }, { "name": "12:30" }, { "name": "13:00" }, { "name": "13:30" },
        { "name": "14:00" }, { "name": "14:30" }, { "name": "15:00" }, { "name": "15:30" }, { "name": "16:00" }, { "name": "16:30" }, { "name": "17:00" },
        { "name": "17:30" }, { "name": "18:00" }, { "name": "18:30" }, { "name": "19:00" }, { "name": "19:30" }, { "name": "20:00" }, { "name": "20:30" },
        { "name": "21:00" }, { "name": "21:30" }, { "name": "22:00" }, { "name": "22:30" }, { "name": "23:00" }, { "name": "23:30" }, { "name": "23:59" },
    ];

    const handleSelectAll = () => {
        const areAllSelected = Object.values(numbers).every((value) => value);
        const updatedNumbers = {};

        for (const key in numbers) {
            updatedNumbers[key] = !areAllSelected;
        }
        setNumbers(updatedNumbers);
    };
    const handleCurrencyOption = (value) => {
        setSelectedCurrencyOption(value);
        if (value != "USD") {
            setCurrencyShow(!currencyShow);
        }
    }

    const handleRateCodeOption = (value) => {
        setSelectedRateCodeOption(value);
    }


    const handleTetherCheckboxChange = () => {
        // e.preventDefault();
        // console.log(isChecked)
        // if (isChecked == false) {
        //     setTetheringShow(!tetheringShow);
        // }
        setIsChecked(!isChecked);

    };
    const handleTether = (e) => {
        e.preventDefault();
        setTetheringShow(!tetheringShow);
        // setIsChecked(!isChecked);

    }
    const handleTetheringSubmit = (e) => {
        e.preventDefault();
        setIsChecked(true);

        setTimeout(() => {
            Swal.fire("Tethering Criteria Submitted Successfully")
            setTetheringShow(false);

        }, 3000);

        // setTetheringShow(false);
    }

    const handleRateSourceOption = (value) => {
        if (value == "Expedia" && selectedCompetitionOption !== "SIPP CODE") {
            setCarDetailsInOption1(expediaOptions)
            setCarDetailsInOption2(expediaOptions)
        } else if (value == "Expedia" && selectedCompetitionOption !== "Car Category") {
            setCarDetailsInOption1(carDetailsInOptionConstant)
            setCarDetailsInOption2(fleetStandardCarDetails)
        } else if (value == "Priceline") {
            setCarDetailsInOption1(carDetailsInOptionConstant)
            setCarDetailsInOption2(fleetStandardCarDetails)
            setSelectedCompetitionOption('SIPP CODE');
        }
        setSelectedRateSourceOption(value);
    };

    const handleCompetitionOption = (value) => {
        setSelectedCompetitionOption(value);
        if (value == "SIPP CODE") {
            setCarDetailsInOption1(carDetailsInOptionConstant)
            setCarDetailsInOption2(fleetStandardCarDetails)
        } else if (value == "Car Category") {
            if (selectedRateSourceOption == "Expedia") {
                setCarDetailsInOption1(expediaOptions)
                setCarDetailsInOption2(expediaOptions)
            } else if (selectedRateSourceOption == "Priceline") {
                setCarDetailsInOption1(carDetailsInOptionConstant)
                setCarDetailsInOption2(fleetStandardCarDetails)
                setSelectedCompetitionOption('SIPP CODE');
            }
        }
    };

    const handleComptitorSippCodes = (index, value) => {
        setSelectedSippValues((prevValues) => {
            const updatedValues2 = [...prevValues];
            updatedValues2[index] = { compSippValues: value };
            return updatedValues2;
        });
    };

    const handleComptitorSippCodes2 = (index, value) => {
        setSelectedSippValues2((prevValues2) => {
            const updatedValues2 = [...prevValues2];
            updatedValues2[index] = { compSippValues2: value };
            return updatedValues2;
        });
    };

    const handleComptitorSippCodes3 = (index, value) => {
        setSelectedSippValues3((prevValues3) => {
            const updatedValues2 = [...prevValues3];
            updatedValues2[index] = { compSippValues3: value };
            return updatedValues2;
        });
    };

    const handleStrategy = (index, value) => {
        setSelectedStrategy((prevValues3) => {
            const updatedValues3 = [...prevValues3];
            updatedValues3[index] = { strategyValues: value };
            return updatedValues3;
        });

        if (value != 'custom') {
            setSelectedCompetitor((prevValues4) => {
                const updatedValues4 = [...prevValues4];
                updatedValues4[index] = { competitorValues: '' };
                return updatedValues4;
            });

            setSelectedAmount((prevValues6) => {
                const updatedValues6 = [...prevValues6];
                updatedValues6[index] = { amountValues: '' };
                return updatedValues6;
            });

            setSelectedChange((prevValues5) => {
                const updatedValues5 = [...prevValues5];
                updatedValues5[index] = { changeValues: '' };
                return updatedValues5;
            });
        }
    };

    const handleAmount = (index, value) => {
        setSelectedAmount((prevValues6) => {
            const updatedValues6 = [...prevValues6];
            updatedValues6[index] = { amountValues: value };
            return updatedValues6;
        });
    };

    const handleChange = (index, value) => {
        setSelectedChange((prevValues5) => {
            const updatedValues5 = [...prevValues5];
            updatedValues5[index] = { changeValues: value };
            return updatedValues5;
        });
    };

    // function scrollToBottom() {
    //     const scrollPosition = document.body.scrollHeight - window.innerHeight;
    //     // Scroll to the calculated position
    //     window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    // }

    function scrollToBottom() {
        const scrollPosition = document.body.scrollHeight - window.innerHeight;
        // Scroll to the calculated position
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }

    const handleCompetitor = (index, value) => {
        setSelectedCompetitor((prevValues4) => {
            const updatedValues4 = [...prevValues4];
            updatedValues4[index] = { competitorValues: value };
            return updatedValues4;
        });
    };

    const handleInputChangeCompanyName = characterEntered => {
        setCompanyName(characterEntered.value);
    };

    const handleInputChangeLocationName = characterEntered => {
        setLocationName(characterEntered.value);
    };

    const handleNumberSelection = (number) => {
        setNumbers({
            ...numbers,
            [number]: !numbers[number],
        });
    };

    const handlePickUpTime = (value) => {
        setSelectedPickUpTime(value);
    };
    const handleParity = (value) => {
        setSelectedRateParity(value);
    };

    const handleAutomationSubmit = (e) => {
        e.preventDefault();
        setRowData({})

        setResponseData('');
        if (companyName === "") {
            Swal.fire('Please select Account Name');
            return;
        }
        if (locationName === "") {
            Swal.fire('Please select a Location to proceed');
            return;
        }
        const hasTrueValueForLor = Object.values(numbers).some((value) => value === true);
        const trueKeys2 = Object.keys(numbers).filter(key => numbers[key] === true);
        setTrueKeys(trueKeys2)
        if (selectedPickUpTime === "") {
            Swal.fire('Please select a PickUp Time');
            return;
        }
        if (!hasTrueValueForLor) {
            Swal.fire("Please select atleast one Lor");
            return;
        }

        // console.log("hasTrueValueForLor",hasTrueValueForLor)
        // console.log("numbers",numbers)
        // return;

        // console.log(selectedCarClass)
        // console.log(selectedCompetitors)
        // console.log(numbers)
        // console.log(selectedPickUpTime)
        // console.log(selectedRateSourceOption)
        // console.log(fromDate)
        // console.log(strategyOptions)


        // setLoading2(true)
        // setButtonDisabled(true);
        // setTimeDuration(timeDurationValue)
        // console.log(selectedOptions)
        if (Array.isArray(selectedOptions) && selectedOptions.length === 0) {
            Swal.fire("Please Select Strategy")
            return;
        }
        if (selectedOptions === "") {
            Swal.fire("Please Select Strategy")
            return;
        }
        const momentObject = Moment(instantFromDate);
        const formattedDate = momentObject.format('MMMM Do, YYYY');
        setHeaderData(locationName + ' - ' + formattedDate)
        scrollToBottom();
        if (selectedCurrencyOption == 'USD') {
            setCurrencyConversionValue(1)
        }
        const body_payload =
        {
            location_name: locationName,
            account_id: company_id.toString(),
            location_id: locationId.toString(),
            pickup_time: selectedPickUpTime,
            rateSourceSelected: selectedRateSourceOption,
            lor: numbers,
            competitors: selectedCompetitors,
            sipp_code: selectedCarClass,
            strategyOptions: selectedOptions,
            currencyConversionValue: currencyConversionValue,
            selectedCurrencyOption: selectedCurrencyOption,
            selectedRateCodeOption: selectedRateCodeOption,
            from_date: new Date(instantFromDate).toDateString(),
            created_by: loggedInUserDetail.userEmail,
            updated_by: loggedInUserDetail.userEmail,
            created_date: new Date(),
            updated_date: new Date()
        };
        setLoading(true);
        
        axios
            .post(baseURL + "/save_automation_instant_info_pro", body_payload)
            .then((res2) => {
                // console.log("RES2:", res2)
                if (res2 !== null && 'data' in res2 && typeof res2.data === 'object') {
                    scrollToBottom();
                    setLoading2(false);
                    setLoading(false);
                    setResponseData(res2.data);
                    setActiveTab(Object.keys(res2.data)[0]);
                    const temp_lowest_values = {}
                    let lor_arr = Object.keys(res2.data);
                    for (let i = 0; i < lor_arr.length; i++) {
                        let arr_inside_lor_arr = Object.keys(res2.data[lor_arr[i]])
                        // console.log("res2.data[lor_arr[i]]", res2.data[lor_arr[i]]);
                        // console.log("arr_inside_lor_arr", arr_inside_lor_arr);
                        temp_lowest_values[lor_arr[i]] = [res2.data[lor_arr[i]][arr_inside_lor_arr[1]], arr_inside_lor_arr[1]]

                    }
                    setSelectedLowestValue(temp_lowest_values);
                } else {
                    setLoading2(false);
                    setLoading(false);
                    Swal.fire('No Response')
                }
            });

    };

    let competitors2 = []
    let carClasses2 = []
    if (responseData !== null) {
        const competitors2 = responseData.competitors ? Object.keys(responseData.competitors) : [];
        const carClasses2 = responseData.lowest_total ? Object.keys(responseData.lowest_total) : [];
    }

    useEffect(() => {
        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);
        setLoggedInUserDetail(foundUser);
        if (foundUser.role === 'SuperAdmin') {
            axios.get(baseURL + "/get_company_details_for_users")
                .then((res) => {
                    setcompanyDetail(res.data);
                });
        }
        else {
            fetch(baseURL + "/get_company_details_for_users_accessWise/" + foundUser.access['InstantAutomationPro_Account Access'] + "*" + foundUser.account_id + "*" + foundUser.account_type.account_type)
                .then((res) => res.json())
                .then((data) => {
                    setcompanyDetail(data);
                });
        }

        fetch(baseURL + "/get_all_rate_codes_names")
            .then((res) => res.json())
            .then((data) => {
                if (Object.keys(data).length > 0) {
                    setRateCodeNames(data);
                }
                else {
                    setRateCodeNames({});
                }
            })
    }, []);

    useEffect(() => {
        if (companyDetail && companyName) {
            let obj_company_detail = companyDetail.filter(
                (value) => value.company_name === companyName
            )[0];
            let temp_company_id = obj_company_detail._id;
            let company_type = obj_company_detail.account_type;

            setcompany_id(temp_company_id);
            setLocationName('')
            setLocationId('')
            setInstantAutomationShow('NO')
            // setLocationEnabledForAutomation('No')
            setListOfRateCodes({})
            setTable([])
            setSelectAllDaysFlag(false)

            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            };

            fetch(baseURL + "/get_company_location/" + temp_company_id, requestOptions)
                .then((res) => res.json())
                .then((data) => {
                    let allTemp = data.res;
                    if (loggedInUserDetail.role === 'SuperAdmin') {
                        if (allTemp.length > 0) {
                            setLocationDetail(allTemp);
                        }
                    }
                    else if (company_type === 'Affiliate' && loggedInUserDetail.account_type.account_type === 'Corporate') {

                        if (allTemp.length > 0) {
                            setLocationDetail(allTemp);
                        }
                    }
                    else {
                        axios.post(baseURL + "/get_individual_user_details", { 'user_email': loggedInUserDetail.userEmail })
                            .then((data) => {
                                if (allTemp.length > 0) {
                                    allTemp = allTemp.filter((val) => val !== undefined && data.data[0].location_allocated[val.location_id]);
                                    setLocationDetail(allTemp);
                                }
                            }
                            )
                    }
                });
        }
    }, [companyName]);

    useEffect(() => {
        let temp_location_id = ''
        if (locationName && locationDetail) {
            temp_location_id = locationDetail.filter((loc) => (loc.location_name === locationName)).map((val) => val.location_id)
            setLocationId(temp_location_id);
            setInstantFromDate(new Date());
            setInstantToDate(new Date());
            setSelectedStrategy([]);
            setSelectedSippValues([]);
            setSelectedSippValues2([]);
            setSelectedSippValues3([]);
            setSelectedCompetitor([]);
            setSelectedChange([]);
            setSelectedAmount([]);
            setCarClassAll(false)
            setCompetitorsAll(false)
            setNumbers({ "1": false, "2": false, '3': false, '4': false, '5': false, '6': false, 'Weekly': false, 'Monthly': false });
            setSelectedPickUpTime('');
            axios
                .get(baseURL + "/get_automation_enabled_info/" + locationName)
                .then((res) => {
                    let automationEnabled = false
                    if (res.data.length > 0) {
                        automationEnabled = res.data[0]['enabled'];
                    }
                    if (automationEnabled === true) {
                        // setLocationEnabledForAutomation("Yes")
                    } else {
                        // setLocationEnabledForAutomation("No")
                    }
                });

            fetch(baseURL + "/get_car_classes/" + temp_location_id)
                .then((res) => res.json())
                .then((data) => {
                    if (data.length > 0) {
                        // console.log(data)
                        let tempArr = [];
                        let tempObj = {}
                        let temp_car_name = [];
                        let temp_arr = []

                        for (let i = 0; i < data.length; i++) {
                            if (data[i] !== undefined && temp_car_name.indexOf(data[i][0]) < 0) {
                                temp_car_name.push(data[i][0]);
                                temp_arr.push(data[i]);
                            }
                        }
                        data = temp_arr;
                        for (let i = 0; i < data.length; i = i + 4) {
                            let tempArr2 = []
                            for (let j = i; j < i + 4; j++) {
                                if (data[j] !== undefined) {
                                    tempArr2.push(data[j][0]);
                                    tempObj[data[j][0]] = false;
                                }
                            }
                            tempArr.push(tempArr2);
                        }

                        // console.log('data', data)
                        // console.log(tempArr)

                        const selectedSippCodeNameOptions = data.map((value) => ({
                            value: value[0],
                            label: value[1],
                        }));
                        const selectedSippCodeNamesArray = selectedSippCodeNameOptions.map(option => option.value);
                        setAllCarClassData(tempArr);
                        setSelectedCarClass(tempObj);
                        // console.log(selectedSippCodeNameOptions)
                        // console.log('selectedSippCodeNamesArray', selectedSippCodeNamesArray)
                        setCarDetails(selectedSippCodeNamesArray);
                        setCarDetailsInOption1(selectedSippCodeNamesArray)
                        setCarDetailsInOptionConstant(selectedSippCodeNamesArray)
                        setInstantAutomationShow('YES')
                    }
                    else {
                        setCarDetails([])
                        setCarDetailsInOption1([])
                        setCarDetailsInOptionConstant([])
                        setInstantAutomationShow('NO')
                    }
                });

            fetch(baseURL + "/get_existing_car_classes_standard")
                .then((res) => res.json())
                .then((data) => {
                    if (data.length > 0) {
                        const standardSippCodeOptions = data.map((value) => ({
                            value: value.SIPP_CODE
                        }));
                        const standardSippCodeArray = standardSippCodeOptions.map(option => option.value);

                        setFleetStandardCarDetails(standardSippCodeArray);
                        setCarDetailsInOption2(standardSippCodeArray)
                    }
                })
            axios
                .get(baseURL + "/get_all_competitor_setup_info/" + locationName)
                .then(response => {
                    if (response.data !== null) {
                        const newArray = response.data.selected_items.map(subArray => subArray[0]);
                        // console.log("newArray")
                        // console.log(newArray)
                        let data = newArray

                        let tempArr = [];
                        let tempObj = {}
                        let temp_car_name = [];
                        let temp_arr = []
                        for (let i = 0; i < data.length; i++) {
                            if (data[i] !== undefined && temp_car_name.indexOf(data[i].value) < 0) {
                                temp_car_name.push(data[i].value);
                                temp_arr.push(data[i]);
                            }
                        }

                        data = temp_arr;
                        for (let i = 0; i < data.length; i = i + 4) {
                            let tempArr2 = []
                            for (let j = i; j < i + 4; j++) {
                                if (data[j] !== undefined) {
                                    tempArr2.push(data[j].value);
                                    tempObj[data[j].value] = false;
                                }
                            }
                            tempArr.push(tempArr2);
                        }
                        setAllCompetitors(tempArr);
                        setSelectedCompetitors(tempObj);
                        // console.log("competitors")
                        // console.log(tempArr)
                        // console.log(tempObj)
                        setCompetitorsList(newArray)
                    }
                })
                .catch(error => {
                    console.error("Second Axios Request Error:", error);
                });
            axios
                .get(baseURL + "/get_automation_instant_info/" + locationName)
        }
    }, [locationName])

    useEffect(() => {
        if (selectedCompetitionOption == "Car Category") {
            setCarDetailsInOption1(expediaOptions)
            setCarDetailsInOption2(expediaOptions)
        } else {
            setCarDetailsInOption1(carDetailsInOptionConstant)
            setCarDetailsInOption2(fleetStandardCarDetails)
        }
    }, [carDetailsInOption1, selectedCompetitionOption]);

    useEffect(() => {
        axios
        .get(baseURL + "/getLocationCurrency/" + locationName)
        .then((res) => {

            console.log("location Currency Response", res)
            setLocationCurrency(res.data)
            // let automationEnabled = false
            // if (res.data.length > 0) {
            //     automationEnabled = res.data[0]['enabled'];
            // }
            // if (automationEnabled === true) {
            //     // setLocationEnabledForAutomation("Yes")
            // } else {
            //     // setLocationEnabledForAutomation("No")
            // }
        });
    }, [loading]);


    //Option for company name
    const companyNameOptions = companyDetail.map((value) => (
        { value: value.company_name, label: value.company_name }
    ));

    //Option for Location name
    const locationNameOptions = locationDetail.map((value) => (
        { value: value.location_name, label: value.location_name === undefined ? value.location_name : value.location_name + " - " + value.location_id.toString().trim().split("-")[1] }
    ));

    return (

        <div style={{ fontSize: '12px', color: 'black', fontWeight: '600' }}>
            <Modal
                show={tetheringShow}
                onHide={() => setTetheringShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                centered
                style={{
                    zIndex: 9999, // Adjust the z-index as needed
                    // Optionally adjust other CSS properties like position, top, left, etc.
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    width: '70% !important',
                    transform: 'translate(-50%, -50%)',
                    // overflow: 'hidden',
                }}
            >
                <div style={{ width: '150%', maxWidth: 'unset' }}>
                    <Modal.Header style={{ backgroundColor: 'orange', textAlign: 'center' }} closeButton >
                        <Modal.Title id="example-modal-sizes-title-lg" style={{ textAlign: 'center' }} >
                            Tethering Criteria
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#cfe2f3' }}>
                        <form style={{ fontSize: '12px' }}>
                            <table className="table" >
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: 'orange', textAlign: 'center' }} scope="col">LOR</th>
                                        <th style={{ backgroundColor: 'orange', textAlign: 'center' }} scope="col">Start</th>
                                        <th style={{ backgroundColor: 'orange', textAlign: 'center' }} scope="col">End</th>
                                        <th style={{ backgroundColor: 'orange', textAlign: 'center' }} scope="col">Days</th>
                                    </tr>
                                </thead>
                                <tbody style={{ textAlign: 'center' }}>
                                    {Object.keys(trueKeys).length > 0 && trueKeys.map((key, index) => (
                                        <tr key={index}>
                                            <td>{key}</td>
                                            <td>
                                                <DatePicker
                                                    size="medium"
                                                    format='MM-DD-YYYY'
                                                    placeholder='mm-dd-yyyy'
                                                    value={moment(instantToDate.valueOf())}
                                                    onChange={(value) => { setInstantToDate(value._d) }}
                                                    style={{ width: '75%' }}
                                                    disabled
                                                />
                                            </td>
                                            <td style={{}}>
                                                <DatePicker
                                                    size="medium"
                                                    format='MM-DD-YYYY'
                                                    placeholder='mm-dd-yyyy'
                                                    style={{ width: '75%' }}
                                                    value={rowData[key]?.defaultDate ? moment(rowData[key].defaultDate) : null}
                                                    onChange={(date) => handleDatePickerChange(key, date)}
                                                    disabledDate={(current) => {
                                                        if (instantFromDate) {
                                                            const startDate = moment(instantFromDate);
                                                            const endDate = moment(instantFromDate).add(400, 'days'); // Allow selection within 7 days of start date
                                                            return current && (current.valueOf() < startDate.valueOf() || current.valueOf() > endDate.valueOf());
                                                        } else {
                                                            return current && current.valueOf() < (new Date().valueOf() - (1 * 24 * 60 * 60));
                                                        }
                                                    }}
                                                />
                                            </td>
                                            <td style={{ marginLeft: '30px' }}>
                                                <tr>
                                                    <th><input type='checkbox' className='form-check-input' checked={defaultCheck[key]} onChange={(e) => changeAllDaysCheckBox(key, e.target.checked)} /> </th>
                                                    <th>Select All</th>
                                                </tr>
                                                {daysNameTable.map((val) => (
                                                    <tr>
                                                        {val.map((v) => (
                                                            v == null ? '' :
                                                                <>
                                                                    <td><input type='checkbox' className='form-check-input' checked={rowData[key]?.[v] || false} onChange={(e) => changeDaysCheckBox(key, v, e.target.checked)} /></td>
                                                                    <td>{v}</td>
                                                                    <td>&nbsp;&nbsp;</td>
                                                                </>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="row" style={{ marginBottom: '10px' }}>
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-2">
                                    <button style={{ width: '143px', fontSize: '12px' }} type="submit" className="btn btn-success" onClick={handleTetheringSubmit} >SUBMIT </button>
                                </div>
                            </div>

                        </form>
                    </Modal.Body>
                </div>
            </Modal>
            <Modal
                size="medium"
                show={currencyShow}
                onHide={() => setCurrencyShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                centered
                style={{ display: 'flex', justifyContent: 'center' }}
            >
                <Modal.Header style={{ backgroundColor: 'orange', textAlign: 'center' }} closeButton >
                    <Modal.Title id="example-modal-sizes-title-lg" style={{ textAlign: 'center' }} >
                        Currency Conversion Value : USD to {selectedCurrencyOption}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: '#cfe2f3' }}>
                    <form style={{ fontSize: '12px' }}>
                        <div className="row pt-2 mx-2">
                            <div className="col-md-3 mb-6">
                            </div>
                            <div className="col-md-9 mb-6">
                                <input
                                    type="number"
                                    className='form-control'
                                    value={currencyConversionValue}
                                    style={{ width: '50%', textAlign: 'center', fontSize: '20px' }}
                                    onChange={(e) => setCurrencyConversionValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
            <form style={{ fontSize: '12px', color: 'black', fontWeight: '600' }}>
                <div className="row pt-2 mx-2" >
                    <div className="col-md-2 mb-3">
                        <label htmlFor="company_name" className="form-label" style={{ marginTop: 5 }}>
                            Account Name
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <Select
                            value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
                            inputId="company_name"
                            name="company_name"
                            options={companyNameOptions}
                            onChange={handleInputChangeCompanyName}
                        />
                    </div>
                </div>

                <div className="row pt-2 mx-2" style={{ fontSize: '12px', color: 'black', fontWeight: '600', marginTop: '5px' }}>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="locationName" className="form-label" style={{ marginTop: 5 }}>
                            PickUp
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <Select
                            value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                            inputId="locationName"
                            name="locationName"
                            options={locationNameOptions}
                            onChange={handleInputChangeLocationName}
                        />
                    </div>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="locationName" className="form-label" style={{ marginTop: 5 }}>
                            DropOff
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <Select
                            value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                            inputId="locationName"
                            name="locationName"
                            options={locationNameOptions}
                            onChange={handleInputChangeLocationName}
                        />
                    </div>
                </div>

                <div className="row pt-2 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="fromDate" className="form-label" style={{ marginTop: 5 }}>
                            From Date
                        </label>
                    </div>
                    <div className="col-md-3 mb-6">
                        <DatePicker
                            size="large"
                            format='MM-DD-YYYY'
                            placeholder='mm-dd-yyyy'
                            // onChange={(date, dateString) => { setFromDate(date); }}
                            onChange={(value) => {
                                setInstantFromDate(value._d);
                                setInstantToDate(value._d);
                                setDefaultDate(value._d)
                            }}
                            disabledDate={(current) => {
                                if (instantToDate && instantFromDate?.valueOf() !== instantToDate?.valueOf()) {
                                    return current && (current.valueOf() > (instantToDate?.valueOf() + (1 * 24 * 60 * 60))) || (current.valueOf() < (new Date().valueOf() - (1000 * 24 * 60 * 60)))
                                }
                                else {
                                    return current && (current.valueOf() < (new Date().valueOf() - (1 * 24 * 60 * 60)))
                                }
                            }}
                            value={moment(instantFromDate.valueOf())}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label" style={{ marginTop: 5 }}>
                            PickUp Time
                        </label>
                    </div>
                    <div className="col-md-3 mb-3" style={{ marginTop: -5 }}>
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td >
                                        <select style={{ textAlign: "center" }}
                                            value={selectedPickUpTime}
                                            onChange={(e) => handlePickUpTime(e.target.value)}
                                        >
                                            <option value="">Select Time</option>
                                            {hours.map((val) => (
                                                <option value={val.name} key={val.name}>
                                                    {val.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-2 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label">
                            RateSource
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td>
                                        <select style={{ textAlign: "center" }}
                                            value={selectedRateSourceOption}
                                            onChange={(e) => handleRateSourceOption(e.target.value)}
                                        >
                                            {rateSourceOptions.map((val) => (
                                                <option value={val.value} key={val.value}>
                                                    {val.value}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label" style={{ marginTop: 5 }}>
                            Competition By
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td >
                                        <select style={{ textAlign: "center" }}
                                            value={selectedCompetitionOption}
                                            onChange={(e) => handleCompetitionOption(e.target.value)}
                                        >
                                            {selectedRateSourceOption === 'Expedia' ?
                                                competitionOptions.map((val) => (
                                                    <option value={val.value} key={val.value}>
                                                        {val.value}
                                                    </option>
                                                ))
                                                :
                                                competitionOptions.map((val) => (
                                                    val.label === "SIPP CODE" && (
                                                        <option value={val.value} key={val.value}>
                                                            {val.value}
                                                        </option>
                                                    )
                                                ))
                                            }
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-2 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label">
                            Rate Code
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td>
                                        <select style={{ textAlign: "center" }}
                                            value={selectedRateCodeOption}
                                            onChange={(e) => handleRateCodeOption(e.target.value)}
                                        >
                                            {rateCodeOptions.map((val) => (
                                                <option value={val.value} key={val.value}>
                                                    {val.value}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label">
                            Currency
                        </label>
                    </div>
                    <div className="col-md-3 mb-3">
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td>
                                        <select style={{ textAlign: "center" }}
                                            value={selectedCurrencyOption}
                                            onChange={(e) => handleCurrencyOption(e.target.value)}
                                        >
                                            {currencyOption.map((val) => (
                                                <option value={val.value} key={val.value}>
                                                    {val.value}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-2 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="Rate_code_picker" className="form-label">
                            Car Class
                        </label>
                    </div>
                    <div className="col-md-2 mb-3" style={{ marginLeft: '0%' }}>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td width='1px' ><input className="form-check-input" type="checkbox"
                                        checked={carClassAll}
                                        onChange={() => handleCarClassAll(!carClassAll)}
                                    /></td>
                                    <td>Select All</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-8 mb-3">
                        <table className="table table-borderless">
                            <tbody>
                                {allCarClassData.map((val, i) => (
                                    <tr>
                                        {val.map((val2, j) => (
                                            <>
                                                <td width='1px' >{<input className="form-check-input" type="checkbox"
                                                    checked={selectedCarClass[val2]} onChange={() => handleCarClass(val2)}
                                                />}</td>
                                                <td >{val2}</td>
                                            </>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-0 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="Rate_code_picker" className="form-label">
                            Competitors
                        </label>
                    </div>
                    <div className="col-md-2 mb-3" style={{ marginLeft: '0%' }}>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td width='1px' ><input className="form-check-input" type="checkbox"
                                        checked={competitorsAll}
                                        onChange={() => handleSelectedCompetitors(!competitorsAll)}
                                    /></td>
                                    <td >Select All</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-8 mb-3">
                        <table className="table table-borderless">
                            <tbody>
                                {allCompetitors.map((val, i) => (
                                    <tr>
                                        {val.map((val2, j) => (
                                            <>
                                                <td width='1px' >{<input className="form-check-input" type="checkbox"
                                                    checked={selectedCompetitors[val2]} onChange={() => handleCompetitors(val2)}
                                                />}</td>
                                                <td >{val2}</td>
                                            </>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-2 mx-2">
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label" style={{ marginTop: 5 }}>
                            Lor's
                        </label>
                    </div>
                    <div className="col-md-2 mb-3" style={{ marginLeft: '0%' }}>
                        <table className="table table-borderless text-left">
                            <tbody className="text-left">
                                <tr>
                                    <td ><input type='checkbox' className='form-check-input' checked={Object.values(numbers).every((value) => value)}
                                        onChange={handleSelectAll} /></td>
                                    <td >Select All</td>
                                    {Object.entries(numbers).map(([number, selected]) => (
                                        <React.Fragment key={number}>

                                            <td ><input type='checkbox' className='form-check-input' checked={selected}
                                                onChange={() => handleNumberSelection(number)} /></td>
                                            <td >{number}</td>
                                            <td >&nbsp;&nbsp;</td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row pt-2 mx-2" style={{ marginBottom: '50px' }}>
                    <div className="col-md-2 mb-3">
                        <label htmlFor="applyRatesToDays" className="form-label" style={{ marginTop: 5 }}>
                            Startegy
                        </label>
                    </div>
                    <div className="col-md-8 mb-3" style={{ marginLeft: '0%' }}>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '200px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="Lowest"
                                checked={selectedOptions.includes('Lowest')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>Lowest</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '200px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="2nd Lowest"
                                checked={selectedOptions.includes('2nd Lowest')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>2nd Lowest</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '179px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="3rd Lowest"
                                checked={selectedOptions.includes('3rd Lowest')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>3rd Lowest</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '104px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="Lowest Off-Airport"
                                checked={selectedOptions.includes('Lowest Off-Airport')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>Lowest Off-Airport</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '113px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="2nd Lowest Off-Airport"
                                checked={selectedOptions.includes('2nd Lowest Off-Airport')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>2nd Lowest Off-Airport</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '104px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="3rd Lowest Off-Airport"
                                checked={selectedOptions.includes('3rd Lowest Off-Airport')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>3rd Lowest Off-Airport</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '137px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="Lowest In-Terminal"
                                checked={selectedOptions.includes('Lowest In-Terminal')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>Lowest In-Terminal</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '104px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="2nd Lowest In-Terminal"
                                checked={selectedOptions.includes('2nd Lowest In-Terminal')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>2nd Lowest In-Terminal</span>
                        </label>
                        <label style={{ display: 'inline-flex', alignItems: 'center', marginRight: '101px' }}>
                            <input
                                type="checkbox"
                                name="strategyOption"
                                value="3rd Lowest In-Terminal"
                                checked={selectedOptions.includes('3rd Lowest In-Terminal')}
                                onChange={handleOptionChange}
                                style={{ width: '20px', height: '20px', marginRight: '7px' }}
                            />
                            <span style={{ marginLeft: '7px' }}>3rd Lowest In-Terminal</span>
                        </label>
                    </div>
                </div>

                {loading && <CustomLoader />}
                <div className="row" style={{ marginBottom: '10px' }}>
                    <div className="col-md-5">
                    </div>
                    <div className="col-md-2">
                        <button style={{ width: '143px', fontSize: '12px' }} type="submit" disabled={buttonDisabled} className="btn btn-success" onClick={handleAutomationSubmit} >Generate Grid </button>
                    </div>
                </div>
            </form>
            {Object.keys(responseData).length !== 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '20px', paddingBottom: '20px', float: "left" }}>
                    <div style={{ border: '2px solid grey', borderRadius: '0 0 7px 7px', width: 'auto', padding: '15px' }}>
                        {/* <div> */}
                        <h2><b>{headerData} - LOR {activeTab}</b></h2>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ position: "sticky", top: '40px', zIndex: 2 }}>
                                <tr>
                                    <th style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle', marginLeft: '30px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <img src={expedia} style={{ marginLeft: '10px', width: '100px', height: '40px' }} alt="" className='logo' />
                                            <span style={{ color: 'white', marginTop: '5px' }}>SIPP CODES ➔</span>
                                        </div>
                                        <div style={{ textAlign: 'center', marginTop: '5px' }}>
                                            <span style={{ color: 'white', marginRight: '5px' }}>Competitors</span>
                                            <span>&#9660;</span> {/* Down arrow symbol */}
                                        </div>
                                    </th>
                                    {Object.entries(responseData[activeTab]?.competitors_result || {}).slice(0, 1).map(([_, carClassData]) => (
                                        Object.keys(carClassData).map((imageName) => (
                                            <th key={imageName} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <img src={baseURL + "/static/img/" + imageName.split('@')[1].trim()} alt={`Image for ${imageName}`} style={{ width: '80px', height: 'auto' }} />
                                                    <span style={{ marginTop: '5px' }}>{imageName.split('@')[0].trim()}</span>
                                                </div>
                                            </th>
                                        ))
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(responseData[activeTab]?.competitors_result || {}).map(([competitor, prices], indx) => (
                                    indx == 0 ?
                                        <tr key={competitor}>
                                            <td style={{ position: "sticky", top: '154px', left: '181px', zIndex: 2, border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <img src={baseURL + "/static/uploads/" + competitor.split('@')[1].trim()} alt={`Image for ${competitor}`} style={{ width: '80px', height: '50px', }} />
                                                    {/* <span style={{ marginTop: '5px' }}>{competitor.split('@')[0].trim()}</span> */}
                                                </div>
                                            </td>
                                            {/* {Object.values(prices).map((price, i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>{price}</td>
                                        ))} */}
                                            {Object.values(prices).map((price, i) => (
                                                <td key={i} style={{
                                                    position: "sticky", top: '154px', zIndex: 1,
                                                    padding: '8px',
                                                    border: '2px solid grey',
                                                    backgroundColor: price.toString().includes('!prasanth') ? 'skyblue' : 'black', // Convert price to string and then check for the condition
                                                    color: price.toString().includes('!prasanth') ? 'black' : 'white', // Convert price to string and then check for the condition
                                                    // color: 'white',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontSize: '14px'
                                                }}>
                                                    {/* {price} */}
                                                    {price.toString().includes('!prasanth') ? price.toString().replace('!prasanth', '') : price} {/* Display price without the !prasanth part if present */}
                                                </td>
                                            ))}
                                        </tr>
                                        :
                                        <tr key={competitor}>
                                            <td style={{ position: "sticky", left: '181px', zIndex: 1, border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <img src={baseURL + "/static/uploads/" + competitor.split('@')[1].trim()} alt={`Image for ${competitor}`} style={{ width: '80px', height: '50px', }} />
                                                    {/* <span style={{ marginTop: '5px' }}>{competitor.split('@')[0].trim()}</span> */}
                                                </div>
                                            </td>
                                            {/* {Object.values(prices).map((price, i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'black', color: 'white', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>{price}</td>
                                        ))} */}
                                            {Object.values(prices).map((price, i) => (
                                                <td key={i} style={{
                                                    zIndex: 1,
                                                    padding: '8px',
                                                    border: '2px solid grey',
                                                    color: price.toString().includes('lowest1') || price.toString().includes('lowest2') ? 'black' : 'white',
                                                    backgroundColor: price.toString().includes('lowest1') ? '#50C878' : price.toString().includes('lowest2') ? '#4169E1' : price.toString().includes('lowest3') ? 'black' : 'black',
                                                    // backgroundColor: price.toString().includes('!prasanth') ? 'skyblue' : 'black', // Convert price to string and then check for the condition
                                                    // color: price.toString().includes('!prasanth') ? 'black' : 'white', // Convert price to string and then check for the condition3
                                                    // color: price.toString().includes('lowest1') ? 'darkgreen' : price.toString().includes('lowest2') ? 'mediumgreen' : price.toString().includes('lowest3') ? 'lightgreen' : 'black',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontSize: '14px'
                                                }}>
                                                    {/* {price} */}
                                                    {price.toString().includes('!lowest1') || price.toString().includes('!lowest2') || price.toString().includes('!lowest3') ? price.toString().replace(/!lowest[123]/g, '') : price}
                                                    {/* {price.toString().includes('!prasanth') ? price.toString().replace('!prasanth', '') : price} Display price without the !prasanth part if present */}
                                                </td>
                                            ))}
                                        </tr>
                                ))}
                                {responseData[activeTab]?.lowest_among_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b>Lowest</b></td>
                                        {Object.entries(responseData[activeTab]?.lowest_among_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                // checked={isEqual(selectedLowestValue, [carClass, price])}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'lowest_among_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.lowest_among_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.lowest_among_competitor, 'lowest_among_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.second_lowest_among_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b>2nd Lowest</b></td>
                                        {Object.entries(responseData[activeTab]?.second_lowest_among_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                // checked={isEqual(selectedLowestValue, [carClass, price])}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'second_lowest_among_competitor'} //second_lowest_among_competitor
                                                // checked={selectedLowestValue[responseData[activeTab]?.second_lowest_among_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.second_lowest_among_competitor, 'second_lowest_among_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.third_lowest_among_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b>3rd Lowest</b></td>
                                        {Object.entries(responseData[activeTab]?.third_lowest_among_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'third_lowest_among_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.third_lowest_among_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.third_lowest_among_competitor, 'third_lowest_among_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.lowest_off_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{
                                            position: "sticky", left: '181px', zIndex: 1,
                                            padding: '8px', border: '2px solid grey',

                                            backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px'
                                        }}><b> Lowest Off-Airport</b></td>
                                        {Object.entries(responseData[activeTab]?.lowest_off_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'lowest_off_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.lowest_off_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.lowest_off_competitor, 'lowest_off_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.second_lowest_off_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b> 2nd Lowest Off-Airport</b></td>
                                        {Object.entries(responseData[activeTab]?.second_lowest_off_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'second_lowest_off_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.second_lowest_off_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.second_lowest_off_competitor, 'second_lowest_off_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.third_lowest_off_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b> 3rd Lowest Off-Airport</b></td>
                                        {Object.entries(responseData[activeTab]?.third_lowest_off_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'third_lowest_off_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.third_lowest_off_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.third_lowest_off_competitor, 'third_lowest_off_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.lowest_on_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b> Lowest In-Terminal</b></td>
                                        {Object.entries(responseData[activeTab]?.lowest_on_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'lowest_on_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.lowest_on_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.lowest_on_competitor, 'lowest_on_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.second_lowest_on_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}><b>2nd Lowest In-Terminal</b></td>
                                        {Object.entries(responseData[activeTab]?.second_lowest_on_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                // checked={activeTab == 2}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'second_lowest_on_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.second_lowest_on_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.second_lowest_on_competitor, 'second_lowest_on_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {responseData[activeTab]?.third_lowest_on_competitor && (
                                    <tr style={{ width: '90px', height: '40px' }}>
                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                            <b>3rd Lowest In-Terminal</b>
                                        </td>
                                        {Object.entries(responseData[activeTab]?.third_lowest_on_competitor || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        <td style={{ padding: '8px', backgroundColor: '#cfe2f3', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                // checked={activeTab == 3}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'third_lowest_on_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.third_lowest_on_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.third_lowest_on_competitor, 'third_lowest_on_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td>
                                    </tr>
                                )}

                                {responseData[activeTab]?.minimum_rates && (
                                    <tr style={{ width: '90px', height: '40px' }}>

                                        <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: '#C60C30', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                            <b>Minimum Rates</b>
                                        </td>
                                        {Object.entries(responseData[activeTab]?.minimum_rates || {}).map(([carClass, price], i) => (
                                            <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: '#C60C30', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                                {price}
                                            </td>
                                        ))}
                                        {/* <td style={{ padding: '8px', backgroundColor: '#cfe2f3', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="radio"
                                                name={"selectedRow" + activeTab}
                                                key={activeTab}
                                                // checked={activeTab == 3}
                                                checked={selectedLowestValue[activeTab]?.length > 1 && selectedLowestValue[activeTab][1] == 'third_lowest_on_competitor'}
                                                // checked={selectedLowestValue[responseData[activeTab]?.third_lowest_on_competitor]}
                                                onChange={() => handleLowestValues([responseData[activeTab]?.third_lowest_on_competitor, 'third_lowest_on_competitor'], activeTab)}
                                                style={{ width: '17px', height: '17px' }}
                                            />
                                        </td> */}
                                    </tr>
                                )}

                                {/* <tr style={{ width: '90px', height: '40px' }}>
                    <td style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize:'14px' }}><b>3rd Lowest In-Terminal</b></td>
                    {Object.entries(responseData[activeTab]?.third_lowest_on_competitor || {}).map(([carClass, price], i) => (
                        <td key={i} style={{ padding: '8px', border: '2px solid grey', backgroundColor: 'orange', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                        {price}
                        </td>
                    ))}
                    <td style={{ padding: '8px', backgroundColor: '#cfe2f3', textAlign: 'center', verticalAlign: 'middle' }}>
                        <input 
                        type="radio"
                        name="selectedRow"
                        key= {activeTab}
                        checked={selectedLowestValue[responseData[activeTab]?.third_lowest_on_competitor]}
                        onChange={() => handleLowestValues([responseData[activeTab]?.third_lowest_on_competitor],activeTab )}
                        style={{ width: '17px', height: '17px'}}

                        />
                    </td>
                    </tr> */}
                                <tr style={{ width: '90px', height: '40px' }}>
                                    <td style={{ position: "sticky", left: '181px', zIndex: 1, padding: '8px', border: '2px solid grey', backgroundColor: '#198754', color: 'black', textAlign: 'center', verticalAlign: 'middle', fontSize: '14px' }}>
                                        <b>Final Rates</b>
                                    </td>
                                    {/* {Array.isArray(selectedLowestValue) && selectedLowestValue.map((rowData, rowIndex) => (
                        Object.entries(rowData).map(([carClass, price], cellIndex) => (
                            <td key={`${rowIndex}-${cellIndex}`} style={{ padding: '8px', border: '2px solid grey', backgroundColor: '#22A7F0', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                <input 
                                    type="number"
                                    value={price} 
                                    key={activeTab}
                                    onChange={(e) => handlePriceChange(e, carClass)}
                                    style={{ width: '100px', textAlign: 'center', fontSize: '14px' }}
                                />
                            </td>
                        ))
                    ))} */}


                                    { //Array.isArray(selectedLowestValue) && selectedLowestValue).map((rowData, rowIndex) => (
                                        selectedLowestValue[activeTab]?.length > 0 && Object.entries(selectedLowestValue[activeTab][0]).map(([carClass, price], cellIndex) => (
                                            <td key={`${1}-${cellIndex}`} style={{ padding: '8px', border: '2px solid grey', backgroundColor: '#198754', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                                                <input
                                                    type="number"
                                                    value={price}
                                                    key={activeTab}
                                                    onChange={(e) => handlePriceChange(e, carClass)}
                                                    style={{ width: '100px', textAlign: 'center', fontSize: '14px' }}
                                                />
                                            </td>
                                        ))
                                        //))
                                    }

                                    {/* {selectedLowestValue.map((rowData, rowIndex) => (
                        Object.entries(rowData).map(([carClass, price], cellIndex) => (
                        <td key={`${rowIndex}-${cellIndex}`} style={{ padding: '8px', border: '2px solid grey', backgroundColor: '#22A7F0', color: 'black', textAlign: 'center', verticalAlign: 'middle' }}>
                            <input 
                            type="number"
                            value={price} 
                            key= {activeTab}
                            onChange={(e) => handlePriceChange(e, carClass)}
                            // key={`${activeTab}-${rowIndex}-${cellIndex}`} // Unique key for each input field
                            // onChange={(e) => handlePriceChange(e, carClass)} // handlePriceChange function to update price
                            style={{ width: '100px', textAlign: 'center', fontSize: '14px' }}
                            />
                        </td>
                        ))
                    ))} */}
                                </tr>
                            </tbody>
                        </table>
                        <div style={{ display: 'flex', alignItems: 'center', float: 'right' }}>
                            <label style={{ marginLeft: '-25%', marginRight: '10%', fontSize: '18px' }}>
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleTetherCheckboxChange}
                                    style={{
                                        width: '17px',
                                        height: '17px',
                                        marginRight: '10px',
                                        // cursor: 'not-allowed',
                                        backgroundColor: isChecked && 'blue',
                                        // Border color to match the background when checked
                                        borderColor: isChecked && 'blue',
                                        // Border style for better visibility
                                        borderStyle: 'solid',
                                        // Border width for better visibility
                                        borderWidth: '1px',
                                    }}
                                // disabled
                                />

                                <button
                                    style={{ width: '150px', marginTop: '7px', textAlign: 'center' }}
                                    type="submit"
                                    className="btn btn-success"
                                    onClick={handleTether}
                                >
                                    Tether Rates
                                </button>

                            </label>
                            <div className="full_display">
                                <PushToRateUpdate accountName={companyName.toString()}
                                    locationName={locationName.toString()}
                                    rateCodes={['778288']}
                                    fromDate={instantFromDate} toDate={fromDate} carClass={carDetails} rates={selectedLowestValue}
                                    fileName={"Rates"} rateCodeNames={'Net Rate POA Non-Inclusive'}
                                    account_id={company_id} location_id={locationId}
                                    rateCodeSelected={selectedRateCodeOption} rateSource={selectedRateSourceOption} rowData={rowData} tetheringShow={isChecked} selectedCurrencyOptionP= {selectedCurrencyOption} locationCurrencyP = {locationCurrency} createdBy ={loggedInUserDetail.userEmail} />
                            </div>

                        </div>
                    </div>
                    <div style={{ bottom: '10px', padding: '5px' }}>
                        {Object.keys(responseData).map((key) => (
                            <button
                                key={key}
                                onClick={(e) => handleTabClick(e, key)}
                                style={{
                                    padding: '10px',
                                    marginLeft: '-50px',
                                    margin: '0 5px',
                                    backgroundColor: activeTab === key ? '#198754' : 'white',
                                    color: activeTab === key ? 'white' : 'black',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px 5px 0 0',
                                    cursor: 'pointer',
                                    width: '100px',
                                }}
                            >
                                LOR {key}
                            </button>
                        ))}
                    </div>
                    <div className="full_display">
                        <ExportToExcelWithRates accountName={companyName.toString()}
                            locationName={locationName.toString()}
                            rateCodes={['778288']}
                            fromDate={instantFromDate} toDate={fromDate} carClass={carDetails} rates={selectedLowestValue}
                            fileName={"Final Rates"} rateCodeNames={'Net Rate POA Non-Inclusive'} account_id={company_id} location_id={locationId} rateCodeSelected={selectedRateCodeOption} rateSource={selectedRateSourceOption} />
                    </div>
                </div>
            )
                : ("")
            }
        </div>
    )
}    